import React from "react";
import { AddOutlined, RemoveOutlined, ShoppingCart, ShoppingCartOutlined } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import "./Cart.css";
import { Link, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

export const generateCartItemsFrom = (cartData, productsData) => {
  if (!cartData || !productsData) return [];
  const mergedCart = cartData.map((item) => ({
    ...item,
    ...productsData.find((product) => item.productId === product._id),
  }));
  return mergedCart;
};

export const getTotalCartValue = (items = []) => {
  let sum = items.reduce((acc, ele) => {
    return acc + ele.cost * ele.qty;
  }, 0);

  return sum;
};

export const getTotalItems = (items = []) => {
  let totalItems = items.reduce((acc, ele) => {
    return acc + ele.qty;
  }, 0);

  return totalItems;
};

const ItemQuantity = ({ value, handleAdd, handleDelete, isReadOnly }) => {
  if (isReadOnly) {
    return <Box>Qty: {value}</Box>;
  }
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={handleDelete}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={handleAdd}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

const Cart = ({
  products,
  items = [],
  handleQuantity,
  isReadOnly = false
}) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  const history = useHistory();
  const routeToCheckout=()=>{
    history.push('/checkout')
  }

  if (!items.length) {
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }

  const isCheckoutPage = location.pathname === '/checkout';

  return (
    <div className="cart">
      {items.map((item) => (
        <Box key={item.productId}>
          {item.qty > 0 ? (
            <Box display="flex" alignItems="flex-start" padding="1rem">
              <Box className="image-container">
                <img
                  src={item.image}
                  alt={item.name}
                  width="100%"
                  height="100%"
                />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                height="6rem"
                paddingX="1rem"
              >
                <div>{item.name}</div>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <ItemQuantity
                    isReadOnly={isReadOnly}
                    value={item.qty}
                    handleAdd={() => handleQuantity(item.productId, item.qty + 1)}
                    handleDelete={() => handleQuantity(item.productId, item.qty - 1)}
                  />
                  <Box padding="0.5rem" fontWeight="700">
                    ${item.cost}
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : null}
        </Box>
      ))}
      <Box
        padding="1rem"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box color="#3C3C3C" alignSelf="center">
          Order total
        </Box>
        <Box
          color="#3C3C3C"
          fontWeight="700"
          fontSize="1.5rem"
          alignSelf="center"
          data-testid="cart-total"
        >
          ${getTotalCartValue(items)}
        </Box>
      </Box>

      {!isCheckoutPage && (
        <Box display="flex" justifyContent="flex-end" className="cart-footer">
         
            <Button
              name="checkout"
              color="primary"
              variant="contained"
              startIcon={<ShoppingCart />}
              className="checkout-btn"
              onClick={routeToCheckout}
            >
              Checkout
            </Button>
       
        </Box>
      )}

      {isReadOnly && (<Box className='cart' padding="1rem">
        <h2>Order Details</h2>
        <Box className='cart-row'>
          <p>Products</p>
          <p>{getTotalItems(items)}</p>
        </Box>

        <Box className='cart-row'>
          <p>Subtotal</p>
          <p>${getTotalCartValue(items)}</p>
        </Box>

        <Box className='cart-row'>
          <p>Shipping Charges</p>
          <p>$0</p>
        </Box>

        <Box className='cart-row' fontSize='1.25rem' fontWeight='700'>
          <p>Total</p>
          <p>${getTotalCartValue(items)}</p>
        </Box>
      </Box>)}
    </div>
  );
};

export default Cart;
